// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.C0pXbdZDNTEWOfuYdjgS{flex-grow:1;margin-left:16px;display:flex;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapTable": `C0pXbdZDNTEWOfuYdjgS`
};
export default ___CSS_LOADER_EXPORT___;
